export default "<i class=\"trend fa\" ng-class=\"{'fa-angle-up':trend.up,'fa-angle-down':trend.down}\"></i>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/vertical-trend.tpl.html
// module id = 438
// module chunks = 0